import * as Yup from "yup";
import { FlexControlProps } from "../models/flexible/flex-field-controller";
import { GeneralFieldController } from "./general-field-controller";
import { ControlState } from "../models/flexible/control-state";
import { Maybe } from "graphql/jsutils/Maybe";
import { AttributeIdentifiers } from "@lyfegen-platform/graphql-schema/models";

export class RequestReceiptDateFieldController extends GeneralFieldController {
	override createValidationRule(initialData: unknown, translation: (key: string) => string): Yup.AnySchema {
		return (super.createValidationRule(initialData, translation) as Yup.DateSchema).max(
			new Date(),
			translation("cannot-be-greater-than-today")
		);
	}
	override useControlState(): ControlState {
		return this.parent.context.noPatients && this.parent.context.noPatients > 0 ? "hidden" : "enabled";
	}

	override useControlProps(): FlexControlProps {
		return {
			cannotBeFuture: true,
		};
	}

	override mapInitialValue(value: unknown): unknown {
		return (
			value ||
			this.parent.context.startingPoint?.data[AttributeIdentifiers.RequestReceiptDate as any] ||
			""
		);
	}
}
